module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page iv. ",
      "epub:type": "pagebreak",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Open access edition funded by the National Endowment for the Humanities.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "35",
      "src": "images/logo-OA-by-nc-nd.jpg",
      "width": "100"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("This work is being made available under the Creative Commons Attribution-Non-Commercial-No Derivatives 4.0 International License (CC BY-NC-ND 4.0). To view a copy of this license, visit "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://creativecommons.org/licenses/by-nc-nd/4.0/",
      "target": "_blank"
    }
  }, [_vm._v("https://creativecommons.org/licenses/by-nc-nd/4.0/")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2019 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2019")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("28 27 26 25 24 23 22 21 20 19    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-63132-5 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-63146-2 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226631462.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226631462.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Fischer, Marilyn, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Jane Addams’s evolutionary theorizing : constructing “Democracy and social ethics” / Marilyn Fischer.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago ; London : The University of Chicago Press, 2019. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCCN")]), _vm._v(" 2018046935 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226631325 (cloth : alk. paper) | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226631462 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCSH")]), _vm._v(": Addams, Jane, 1860–1935. | Addams, Jane, 1860–1935. Democracy and social ethics. | Social evolution. | Evolution—Moral and ethical aspects. | Democracy. | Social ethics. | Pragmatism.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HV")]), _vm._v("28."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A")]), _vm._v("35 "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("F")]), _vm._v("56 2019 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DDC")]), _vm._v(" 303.3/720973—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2018046935",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018046935")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1147b12e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Fischer-OA-0004.vue
// module id = 63
// module chunks = 0